<div class="modal-header">
    <h4 class="modal-title fw-semibold">Order Details</h4>
    <button
        type="button"
        class="btn-close"
        aria-label="Close"
        (click)="close()"
    ></button>
</div>
<div class="modal-body">
    <!-- Course Summary -->
    @if (data.courseSummaries.length > 0) {
        <div class="mb-4">
            <div class="vstack gap-2">
                @for (course of data.courseSummaries; track $index) {
                    <div class="rounded border bg-body vstack">
                        <div class="px-3 py-2">
                            <h6 class="m-0 fw-semibold">{{ course.courseName }}</h6>
                        </div>
                        <hr class="m-0" />
                        <div class="px-3 py-2 vstack gap-1">
                            @for (item of course.items; track $index) {
                                <div>
                                    <span class="fw-medium">{{ item.productName }}</span>
                                    <span class="fw-semibold">&nbsp;x{{ item.quantity }}</span>
                                    @if (item.modifierNames.length > 0) {
                                        <span class="small text-body-secondary"> — {{ item.modifierNames.join(', ') }}</span>
                                    }
                                </div>
                            }
                        </div>
                    </div>
                }
            </div>
        </div>
    }

    <!-- Per-Cover Table -->
    @if (data.rows.length > 0) {
        <div>
            <div class="fw-semibold text-uppercase small border-bottom border-2 pb-1 mb-2">Per Cover</div>
            <div class="table-responsive">
                <table class="table table-sm mb-0 align-middle">
                    <thead>
                        <tr>
                            <th class="py-2 px-2 text-nowrap" style="width: 120px;">Guest</th>
                            @for (course of data.courseNames; track $index) {
                                <th class="py-2 px-2 text-nowrap">{{ course }}</th>
                            }
                        </tr>
                    </thead>
                    <tbody>
                        @for (row of data.rows; track $index; let rowIdx = $index) {
                            <tr class="align-top">
                                <td class="py-2 px-2">
                                    <div class="fw-medium">{{ row.name }}</div>
                                    @if (row.notes) {
                                        <div class="small text-body-secondary fst-italic">{{ row.notes }}</div>
                                    }
                                </td>
                                @for (course of data.courseNames; track $index) {
                                    <td class="py-2 px-2">
                                        @for (item of getSelectionsForCourse(row, course); track $index; let last = $last) {
                                            <div [class.mb-1]="!last">{{ item }}</div>
                                        }
                                        @if (getSelectionsForCourse(row, course).length === 0) {
                                            <span class="text-body-secondary">—</span>
                                        }
                                    </td>
                                }
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
        </div>
    }
</div>
<div class="modal-footer">
    <button
        type="button"
        class="btn btn-outline-secondary hstack gap-2"
        (click)="onPrint()"
    >
        <img
            ngSrc="assets/printer/normal.svg"
            alt="Print"
            height="16"
            width="16"
        />
        Print
    </button>
    <button
        type="button"
        class="btn btn-secondary"
        (click)="close()"
    >
        Close
    </button>
</div>
